import React, { useState, useEffect } from "react";
import {
  Badge,
  ButtonGroup,
  Card,
  Col,
  Row,
  Form,
  Button,
  Dropdown,
  Alert,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import "moment/locale/es";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import SidebarDashboard from "../../../components/SidebarDashboard";
import CustomPagint from "../../../components/CustomPagint";
import CustomTable from "../../../components/CustomTable";
import {
  getWorkflowBlocks,
  saveWorkflowBlock,
  editWorkflowBlock,
  deleteWorkflowBlock,
} from "../../../redux/on&offBoarning/workflowbock/actions";

const WorkFlowBlo = (props) => {
  //* States
  const [showSidebard, setShowSideBar] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [item, setItem] = useState(null);
  const [validated, setValidated] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [filter, setFilter] = useState({ id: "nombre", desc: "Nombre" });
  const [search, setSearch] = useState("");
  //const [validatedDate, setValidateDate] = useState(false);

  //* Redux
  const {
    loader,
    saveLoader,
    workflowBlockLength,
    workflowBlocks,
    formErrors,
    error,
  } = useSelector((store) => store.workflowBlock);

  //* Variables
  workflowBlocks.sort((a, b) => (a.nombre > b.nombre ? 1 : -1));

  const dispatch = useDispatch();
  const { goBack } = useHistory();
  //moment.locale('es');
  const pages = Math.ceil(workflowBlockLength / limit);
  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
  ];
  const columns =
    parseInt(props.match.params.type) === 1
      ? [
          {
            id: "countAct",
            Header: "N° actividades",
            Cell: (value) => (
              <Badge
                variant={
                  value.row.original.workflow_tareas ? "info" : "warning"
                }
              >
                {value.row.original.workflow_tareas
                  ? value.row.original.workflow_tareas.length
                  : 0}
              </Badge>
            ),
          },
          {
            Header: "Nombre",
            accessor: "nombre",
          },
          {
            Header: "Fecha de inicio",
            Filter: "",
            Cell: (value) =>
              moment(value.row.original.fecha_inicio).format("DD/MM/YYYY"),
          },
          {
            Header: "Fecha de fin",
            Filter: "",
            Cell: (value) => (
              <div
                style={{ width: "8.9rem" }}
                className={`rounded-pill text-white text-center px-2 ${
                  moment(moment().format("YYYY-MM-DD")).diff(
                    moment(value.row.original.fecha_fin),
                    "days"
                  ) > 0
                    ? "bg-danger"
                    : moment(value.row.original.fecha_fin).diff(
                        moment(moment().format("YYYY-MM-DD")),
                        "days"
                      ) === 1
                    ? "bg-info"
                    : "bg-success"
                }`}
              >
                {moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}
              </div>
            ),
          },
          {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
              <div className="btn-group" role="group">
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() =>
                    handleEditWorkFlowBlock(value.row.original, value.row.index)
                  }
                >
                  <i className="material-icons">edit</i>
                </Button>
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    handleDeleteWorkFlowBlock(
                      value.row.original.id,
                      value.row.index
                    )
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
                <Link
                  to={`/workflow-checklist/${value.row.original.id}/${value.row.original.nombre}/${props.match.params.workflowid}/1`}
                  className="btn btn-default btn-sm text-success"
                >
                  <i className="material-icons">add_task</i>
                </Link>
              </div>
            ),
          },
        ]
      : [
          {
            id: "countAct",
            Header: "N° actividades",
            Cell: (value) => (
              <Badge
                variant={
                  value.row.original.workflow_tareas ? "info" : "warning"
                }
              >
                {value.row.original.workflow_tareas
                  ? value.row.original.workflow_tareas.length
                  : 0}
              </Badge>
            ),
          },
          {
            Header: "Nombre",
            accessor: "nombre",
          },
          {
            Header: "Fecha de inicio",
            Filter: "",
            Cell: (value) =>
              moment(value.row.original.fecha_inicio).format("DD/MM/YYYY"),
          },
          {
            Header: "Fecha de fin",
            Filter: "",
            Cell: (value) => (
              <div
                style={{ width: "8.9rem" }}
                className={`rounded-pill text-white text-center px-2 ${
                  moment(moment().format("YYYY-MM-DD")).diff(
                    moment(value.row.original.fecha_fin),
                    "days"
                  ) > 0
                    ? "bg-danger"
                    : moment(value.row.original.fecha_fin).diff(
                        moment(moment().format("YYYY-MM-DD")),
                        "days"
                      ) === 1
                    ? "bg-info"
                    : "bg-success"
                }`}
              >
                {moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}
              </div>
            ),
          },
          {
            Header: "Estado",
            Filter: "",
            Cell: (value) => (
              <div className="d-flex justify-content-between">
                <div
                  className={`rounded-pill ${
                    value.row.original.estado ? "bg-success" : "bg-danger"
                  }`}
                  style={{
                    width: "3rem",
                    height: "1rem",
                    marginRight: ".6rem",
                  }}
                ></div>
                <Form.Check
                  disabled
                  inline
                  checked={value.row.original.estado}
                />
              </div>
            ),
          },
          {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
              <div className="btn-group" role="group">
                {parseInt(props.match.params.type) === 1 && (
                  <>
                    <Button
                      size="sm"
                      variant="link"
                      type="button"
                      onClick={() =>
                        handleEditWorkFlowBlock(
                          value.row.original,
                          value.row.index
                        )
                      }
                    >
                      <i className="material-icons">edit</i>
                    </Button>
                    <Button
                      size="sm"
                      className="text-danger"
                      variant="link"
                      type="button"
                      onClick={() =>
                        handleDeleteWorkFlowBlock(
                          value.row.original.id,
                          value.row.index
                        )
                      }
                    >
                      <i className="material-icons">close</i>
                    </Button>
                  </>
                )}
                <Link
                  to={`/workflow-checklist/${value.row.original.id}/${value.row.original.nombre}/${props.match.params.workflowid}/${props.match.params.type}`}
                  className="btn btn-default btn-sm"
                >
                  <i className="material-icons">list</i>
                </Link>
              </div>
            ),
          },
        ];
  //* Methods
  const getPlantWorkflowBlocks = (offs = offset, lim = limit, filt = search) =>
    dispatch(
      getWorkflowBlocks(
        {
          limit: lim,
          offset: offs,
          id_workflow: props.match.params.workflowid,
          tipo_busqueda: filter.id,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => getPlantWorkflowBlocks(), [props.match.params.type]);

  /*Paginación*/
  /*  const prev = () => {
    if(currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    const oOffset = offset - limit;
    setOffset(oOffset);
    
    dispatch(getWorkflowBlocks({
      offset: oOffset,
      limit: limit,
      id_workflow: props.match.params.workflowid,
      tipo_busqueda: filter,
      filter: search
    }, parseInt(props.match.params.type)));

  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);
    const oOffset = offset + limit;
    setOffset(oOffset);
    dispatch(getWorkflowBlocks({
      offset: oOffset,
      limit: limit,
      id_workflow: props.match.params.workflowid,
      tipo_busqueda: filter,
      filter: search
    }, parseInt(props.match.params.type)));
  }

  const last = () => {
    setCurrentPage(pages);
    const oOffset = (pages * limit) - limit;
    setOffset(oOffset);
    dispatch(getWorkflowBlocks({
      offset: oOffset,
      limit: limit,
      id_workflow: props.match.params.workflowid,
      tipo_busqueda: filter,
      filter: search
    }, parseInt(props.match.params.type)));
  }

  const first = () => {
    setCurrentPage(1);
    const oOffset = 0;
    setOffset(oOffset);
    dispatch(getWorkflowBlocks({
      offset: oOffset,
      limit: limit,
      id_workflow: props.match.params.workflowid,
      tipo_busqueda: filter,
      filter: search
    }, parseInt(props.match.params.type)));
  }

  const onChangeLimit = value => {
    const oLimit = parseInt(value);
    const oOffset = 0;
    setLimit(oLimit);
    setOffset(oOffset);
    setCurrentPage(1);
    dispatch(getWorkflowBlocks({
      offset: oOffset,
      limit: oLimit,
      id_workflow: props.match.params.workflowid,
      tipo_busqueda: filter,
      filter: search
    }, parseInt(props.match.params.type)));
  }; */

  /*fin paginación*/

  const onSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPlantWorkflowBlocks(oOffset, limit, e.target.filter.value);
  };

  const handleCreateWorkFlowBlock = () => {
    setEdit(false);
    setItem(null);
    setShow(true);
    setValidated(false);
  };

  const handleEditWorkFlowBlock = (item, rowIndx) => {
    setEdit(true);
    setItem(item);
    setShow(true);
    setValidated(false);
    setRowIndex(rowIndx);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    // if (moment(e.target.datest.value) > moment(e.target.datef.value)){
    //   setValidated(false);
    //   setValidateDate(true);
    //   return;
    // }

    const req = {
      nombre: e.target.nombre.value,
      descripcion: e.target.desc.value,
      // fecha_inicio: moment(e.target.datest.value).format('YYYY-MM-DD'),
      // fecha_fin: moment(e.target.datef.value).format('YYYY-MM-DD'),
      estado: false,
      workflow: parseInt(props.match.params.workflowid),
    };

    if (edit) {
      req.posicion = item.posicion;
      dispatch(
        editWorkflowBlock(
          req,
          rowIndex,
          item.id,
          parseInt(props.match.params.type)
        )
      );
    } else {
      req.posicion = workflowBlockLength + 1;
      dispatch(saveWorkflowBlock(req, parseInt(props.match.params.type)));
    }
    setShow(false);
  };

  const handleDeleteWorkFlowBlock = (id, rowIndx) => {
    if (window.confirm("¿Estás seguro de querer eliminar este WorkFlow?")) {
      dispatch(
        deleteWorkflowBlock(id, rowIndx, parseInt(props.match.params.type))
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setSearch(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPlantWorkflowBlocks(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShowSideBar(showSidebard ? false : true);
  const handleClose = () => setShow(false);

  return (
    <div className="p-lg-2 p-md-2">
      <CustomNavbar />
      {parseInt(props.match.params.type) === 1 ? (
        <SidebarConfig show={showSidebard} onShowSidebar={onShowSidebar} />
      ) : (
        <SidebarDashboard show={showSidebard} onShowSidebar={onShowSidebar} />
      )}
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="mb-4">
            <div className="d-flex justify-content-start align-items-center">
              {/* <Link to={parseInt(props.match.params.type) === 1 ? "/workflow" : "/Monitor-Onboarding"} className="btn btn-sm font-weight-bold mr-4"><i className="material-icons">arrow_back</i></Link> */}
              <Button
                onClick={() => goBack(-1)}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i
                  className="material-icons"
                  style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                >
                  folder
                </i>{" "}
                {props.match.params.workflowname}
              </h4>
            </div>
            <hr />
          </div>
          <Form onSubmit={onSearch}>
            <Row className="justify-content-start align-items-center flex-nowrap">
              <Col xs="auto" className="px-1">
                <h4 className="m-0 ml-3">
                  {parseInt(props.match.params.type) === 1
                    ? "Plantillas workFlows bloques"
                    : "WorkFlows bloques"}{" "}
                  <i className="material-icons">star</i>
                </h4>
              </Col>
              {parseInt(props.match.params.type) === 1 ? (
                <Col xs="auto" className="px-1">
                  <Button
                    onClick={handleCreateWorkFlowBlock}
                    variant="primary"
                    className="btn btn-sm rounded-pill font-weight-bold"
                  >
                    <i className="material-icons">add</i> Crear nuevo bloque
                  </Button>
                </Col>
              ) : null}
              <Col xs="auto">
                <Form.Control
                  id="filter"
                  name="filter"
                  //onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar / Filtrar WorkFlow"
                  className="rounded-pill form-control-sm"
                  type="search"
                ></Form.Control>
              </Col>
              <Col xs="auto" className="px-1">
                <ButtonGroup className="d-flex align-items-center">
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="mr-1"
                  >
                    <i className="material-icons">visibility</i>
                  </Button>
                  <Dropdown className="mr-2">
                    <Dropdown.Toggle variant="primary" className="btn-sm font">
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((item) => (
                        <Dropdown.Item
                          onClick={() => setFilter(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {filter.desc}
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
          {!!error && (
            <Alert variant="danger" className="mt-4 mb-1">
              {error}
            </Alert>
          )}
          <Card className="border-0 mt-2">
            <Card.Body className="px-0">
              {loader ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : workflowBlocks.length > 0 ? (
                <>
                  <CustomTable columns={columns} data={workflowBlocks} />
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={workflowBlockLength}
                    pages={pages}
                    pagFunc={getPlantWorkflowBlocks}
                  />
                </>
              ) : (
                <Alert variant="info">
                  Aún no hay Bloques registrados para este proceso, comienza
                  agregando algunos.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? `Editar WorkFlow ${item.nombre}` : "Crear Bloque"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {formErrors && (
              <Alert variant="danger">
                <h6 className="font-weight-bold">
                  Hemos experimentado los suguientes errores:
                </h6>
                {Array.isArray(formErrors) ? (
                  <ul className="list-unstyled">
                    {formErrors.map((item, inx) => (
                      <li key={inx}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  formErrors
                )}
              </Alert>
            )}
            <Form.Group className="mb-3">
              <Form.Label className="ml-2">Nombre</Form.Label>
              <Form.Control
                className="rounded-pill"
                id="nombre"
                name="nombre"
                type="text"
                placeholder="Nombre"
                required
                defaultValue={item ? item.nombre : null}
              />
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="ml-2">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                id="desc"
                name="desc"
                type="text"
                placeholder="Descripción"
                required
                defaultValue={item ? item.descripcion : null}
              />
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group className="mb-3">
            <Form.Label className="ml-2">Fecha de inicio</Form.Label>
            <Form.Control
              className={`rounded-pill ${validatedDate ? 'is-invalid' : null}`}
              id="datest" 
              name="datest" 
              type="date" 
              placeholder="Fecha de inicio"
              required
              defaultValue={item ? item.fecha_inicio: null}  />
            <Form.Control.Feedback type="invalid">
              <ul className="list-unstyled">
                <li>**Campo requerido</li>
                <li>**La fecha de inicio no puede ser mayor que la fecha de fin.</li>
              </ul>
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="ml-2">Fecha de fin</Form.Label>
            <Form.Control
              className={`rounded-pill ${ validatedDate ? 'is-invalid' : null}`}
              id="datef" 
              name="datef" 
              type="date" 
              placeholder="Fecha de fin"
              required
              defaultValue={item ? item.fecha_fin: null}  />
            <Form.Control.Feedback type="invalid">
              <ul className="list-unstyled">
                <li>**Campo requerido</li>
                <li>**La fecha de fin no puede ser menor que la fecha de inicio.</li>
              </ul>
            </Form.Control.Feedback>
          </Form.Group> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoader}
              variant="primary"
              type="submit"
            >
              {saveLoader ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default WorkFlowBlo;
